import { SxProps } from '@mui/material'

import theme from '../../../../shared/styles/themes/default.theme'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.75),
    padding: theme.spacing(2.5),
    borderRadius: theme.shape.borderRadius / 4,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      borderRadius: 0,
      boxShadow: 'none',
      backgroundColor: 'transparent',
      padding: theme.spacing(0, 3),
      paddingBottom: theme.spacing(1)
    }
  } as SxProps,

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  } as SxProps,

  titleText: {
    fontSize: 18,
    fontWeight: 700,
    color: theme.palette.grey[800],
    fontFamily: theme.typography.fontFamily
  } as SxProps,

  editIcon: {
    color: theme.palette.info.main,
    cursor: 'pointer',
    padding: theme.spacing(0.5),
    minWidth: 'auto',
    '&:hover': { backgroundColor: 'transparent', opacity: 0.7 }
  } as SxProps,

  divider: {
    backgroundColor: theme.palette.grey[200],
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  } as SxProps,

  contentRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1.5)
  } as SxProps,

  avatarWrapper: {
    flexShrink: 0
  } as SxProps,

  infoColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    minWidth: 0,
    alignItems: 'flex-start',
    textAlign: 'left'
  } as SxProps,

  nameText: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.palette.grey[800],
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left'
  } as SxProps,

  addressRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75)
  } as SxProps,

  addressText: {
    fontSize: 12,
    fontWeight: 400,
    color: theme.palette.grey[500],
    fontFamily: theme.typography.fontFamily
  } as SxProps,

  locationIcon: {
    fontSize: 16,
    color: theme.palette.grey[500],
    flexShrink: 0
  } as SxProps
}

export default styles
